<template>
 <div>
  <v-select
    @change="listOnSelect($event)"   
    item-text="label" 
    item-value="value"  
    v-model="currentValue" 
    ref="ele"
    :class="css"
    :items="users"
    :outlined="outlined"
    :dense="dense"
  >
  </v-select>
  </div>
</template>

<script>
import dataSvc from "@/services/dataService";
export default {
  props:['value', "css", "token", "outlined", "dense", "isRequired"], 
  data() {
    return {
      currentValue: null, 
      users:[]   
    };
  },
  methods: {    
    listOnSelect(event) { 
       this.$emit('input', this.currentValue);             
    },
    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
     },  
    setupDD() {      
      dataSvc
        .getHttp()
        .post("v1/leadopportunities/leads/user-access-list-with-token", {token: this.token })
        .then(res => {
           let options = res.data.users;    
           let groups = options.map(x=>x.group).filter(this.onlyUnique).sort()
           groups.forEach(g => {
                this.users.push({header:g})
                options.filter(x=>x.group === g).forEach(o=>{
                    this.users.push(o)
                })
           });            
        });
    }
  },
  mounted() {
    setTimeout(() => {
      this.setupDD();
    }, 100);
  },
  watch:{
    'value':{
      handler(n){
        this.currentValue = n       
      },deep: false,immediate:true
    }
  }
};
</script>
 